import {
  GET_SUPPORT_TABLES,
  GET_SUPPORT_TABLE,
  PATCH_SUPPORT_TABLE,
  RESET_SUPPORT_TABLE,
  DELETE_SUPPORT_TABLE,
  GET_SUPPORT_TYPE,
} from './types'

const initialState = {
  supportTables: [],
  supportTable: {},
  loading: false,
  isUpdated: false,
}

const supportTablesReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case GET_SUPPORT_TABLES:
      return {
        ...state,
        supportTables: payload,
      }
    case GET_SUPPORT_TYPE:
      return {
        ...state,
        supportTypes: payload,
      }
    case GET_SUPPORT_TABLE:
      return {
        ...state,
        supportTable: payload,
      }
    case PATCH_SUPPORT_TABLE:
      return {
        ...state,
        supportTable: payload,
        isUpdated: true,
      }
    case RESET_SUPPORT_TABLE:
      return {
        ...state,
        supportTables: payload,
        isUpdated: false,
      }
    case DELETE_SUPPORT_TABLE:
      return {
        ...state,
        supportTables: {
          ...state.supportTables,
          query: {
            ...state.supportTables.query,
            totalRecords: state.supportTables.query.totalRecords - 1,
          },
          data: state.supportTables.data.filter((table) => table.id !== payload),
        },
        isUpdated: true,
      }
    default:
      return state
  }
}
export default supportTablesReducer
